import React, { useCallback } from 'react'
import AssembliesPrincipalView from './assemblies-principal.view';
import AssembliesAddDetailView from './assemblies-add-detail.view';
import AssembliesDetailView from './aseemblies-detail.view';

const AssembliesConfigView = (props) => {
    let {
        nameComponent,
        assemblies
    } = props

    const renderAssemblies = useCallback(() => {
        switch (nameComponent) {
            case 'principal':
                return (
                    <AssembliesPrincipalView {...props} />
                )
            case 'detail':
                return (
                    <AssembliesAddDetailView  {...props} />
                )
            case 'add':
                return (
                    <AssembliesAddDetailView  {...props} />
                )

            default:
                return;
        }
    }, [
        nameComponent,
        assemblies
    ]);

    return <>{renderAssemblies()}</>;
}

export { AssembliesConfigView as default }